import { useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { useRefetchDeskNames } from './queries';

export const useSetDeskNameMutation = (options) => {
  const _options = useCreateOptions(options);
  return useMutation(setDeskNameFn, _options);
};

export const useDeleteDeskMutation = (options) => {
  const _options = useCreateOptions(options);
  return useMutation(deleteDesk, _options);
};

function useCreateOptions(options) {
  const refetchDeskNames = useRefetchDeskNames();

  return {
    ...options,
    onSuccess: (data) => {
      if (data !== 'Error') {
        refetchDeskNames();

        if (options?.onSuccess) {
          options.onSuccess(data);
        }
      }
    },
  };
}

function createDesk({ serviceCompanyId, deskName }) {
  return request.post(
    'Acceptance/create_desk',
    undefined,
    'Не удалось создать стол',
    'Error',
    undefined,
    { serviceCompanyId, deskName }
  );
}

function updateDesk({ deskId, deskName }) {
  return request.put(
    'Acceptance/update_desk',
    undefined,
    'Не удалось изменить наименование стола',
    'Error',
    undefined,
    { deskId, deskName }
  );
}

function setDeskNameFn({ isEdit, ...data }) {
  return isEdit ? updateDesk(data) : createDesk(data);
}

function deleteDesk(deskId) {
  return request.delete(
    'Acceptance/delete_desk',
    { deskId },
    'Не удалось удалить стол',
    'Error'
  );
}
